import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo-transparent.png';
import logo2 from '../assets/logo2.png';
import './CSS/App.css';

const FeatureCard = ({ to, icon, title, subtitle, hot }) => (
  <Link to={to} className="card-link">
    <div className={`feature-card ${hot ? 'hot' : ''}`}>
      <div className="card-icon">{icon}</div>
      <div className="card-text">
        <h3>{title}</h3>
        <p>{subtitle}</p>
      </div>
      {hot && <span className="hot-badge">HOT</span>}
    </div>
  </Link>
);

class App extends Component {
  render() {
    return (
      <div className="app-container">
        {/* HEADER */}
        <header className="app-header">
          <img className="logo" src={logo} alt="Main Logo" />
          <h1>Thailand’s Finest OCR & Blockchain Document System</h1>
          <p className="tagline">
            OCR • Verification • Hashing • Trust on Blockchain
          </p>
        </header>

        {/* DASHBOARD GRID */}
        <section className="dashboard-grid">
          <FeatureCard
            to="/register"
            icon="📝"
            title="Register"
            subtitle="Create your secure account"
          />

          <FeatureCard
            to="/searchengine"
            icon="🔍"
            title="Search on Blocks"
            subtitle="Explore blockchain records"
          />

          <FeatureCard
            to="/verifydoc"
            icon="✅"
            title="Verify Document"
            subtitle="Check document authenticity"
          />

          <FeatureCard
            to="/login3"
            icon="🖼️"
            title="Hash Image / Certificate"
            subtitle="Secure visual files"
          />

          <FeatureCard
            to="/login4"
            icon="📄"
            title="Hash PDF"
            subtitle="Immutable PDF hashing"
          />

          <FeatureCard
            to="/login5"
            icon="🇹🇭"
            title="Thai OCR"
            subtitle="High-accuracy Thai OCR"
            hot
          />

          <FeatureCard
            to="/verifyslipoptions"
            icon="🏦"
            title="Verify Bank Slip"
            subtitle="Detect fake slips"
            hot
          />

          <FeatureCard
            to="/login6"
            icon="🔗"
            title="Certificate URL"
            subtitle="Generate verifiable links"
          />

          <FeatureCard
            to="/login2"
            icon="✍️"
            title="Digital Signature"
            subtitle="Sign documents digitally"
          />

          <FeatureCard
            to="/webcamcapture"
            icon="📷"
            title="Webcam Capture"
            subtitle="Capture & process instantly"
          />

          <FeatureCard
            to="/login8"
            icon="🔳"
            title="QR Code Generator"
            subtitle="Custom blockchain QR"
            hot
          />

          <FeatureCard
            to="/paymentmethods"
            icon="💳"
            title="Buy Credits"
            subtitle="Top-up your balance"
          />
        </section>

        {/* EXTERNAL BLOCKCHAIN */}
        <div className="external-block">
          <a
            href="http://128.199.98.182:3000/login7"
            target="_blank"
            rel="noopener noreferrer"
            className="external-btn"
          >
            🚀 Open External Blockchain
          </a>
        </div>

        {/* FOOTER */}
        <footer className="app-footer">
          <p>Powered by</p>
          <img className="logo2" src={logo2} alt="Logo 2" />
          <p>New Wave Consulting Group</p>
        </footer>
      </div>
    );
  }
}

export default App;
